import { useMemo, useState } from "react";
import LiveChatScreenSidebar from "./LiveChatSidebar";
import IndividualChatScreen from "./IndividualChat/IndividualChatScreen";
import GroupChatScreen from "./GroupChat/GroupChatScreen";
import { ChatScreenType, ChatScreenState } from "./types/chat";
import { useLiveChatState } from "./Provider/LiveChatStateProvider";

const LiveChatScreen = () => {
  const { currentScreen, handleScreenChange } = useLiveChatState();

  const handleDocumentTypeClick = (documentType: "financial" | "legal") => {
    // setCurrentScreen({
    //   type: ChatScreenType.FINANCIAL_DOC,
    //   data: { documentType }
    // });
  };

  const renderScreen = useMemo(() => {
    if (!currentScreen) return null;
    // return (
    //   // <LiveChatUserBackup />
    //   // <FuelCapLiveChatUserScreen message={currentScreen.data.message} />
    // )

    switch (currentScreen.type) {
      case ChatScreenType.USER:
        return currentScreen.data.user ? (
          <IndividualChatScreen
            user={currentScreen.data.user}
            onDocumentTypeClick={handleDocumentTypeClick}
          />
        ) : null;
      case ChatScreenType.GROUP:
        return <GroupChatScreen />;
      default:
        return null;
    }
  }, [currentScreen]);

  return (
    <div className="tw-relative">
      <div className="tw-flex tw-px-6">
        <div className="tw-w-[23%]">
          <aside>
            <LiveChatScreenSidebar onScreenChange={handleScreenChange} />
          </aside>
        </div>
        <div className="tw-w-full">{renderScreen}</div>
      </div>
    </div>
  );
};

export default LiveChatScreen;
